// Migrate values from src/assets/Fonts.js here if needed

export const typography = {
  fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
  h1: { fontWeight: 700, fontSize: '3rem', lineHeight: 1.2 },
  h2: { fontWeight: 700, fontSize: '2.25rem', lineHeight: 1.25 },
  h3: { fontWeight: 600, fontSize: '1.75rem', lineHeight: 1.3 },
  h4: { fontWeight: 600, fontSize: '1.5rem', lineHeight: 1.35 },
  h5: { fontWeight: 600, fontSize: '1.25rem', lineHeight: 1.4 },
  h6: { fontWeight: 600, fontSize: '1.125rem', lineHeight: 1.45 },
  subtitle1: { fontWeight: 500, fontSize: '1rem', lineHeight: 1.5 },
  subtitle2: { fontWeight: 500, fontSize: '0.875rem', lineHeight: 1.5 },
  body1: { fontWeight: 400, fontSize: '1rem', lineHeight: 1.6 },
  body2: { fontWeight: 400, fontSize: '0.875rem', lineHeight: 1.57 },
  button: { fontWeight: 600, textTransform: 'none' },
  caption: { fontWeight: 400, fontSize: '0.75rem', lineHeight: 1.66 },
  overline: { fontWeight: 600, fontSize: '0.75rem', letterSpacing: '0.06em', textTransform: 'uppercase' },
};


